// Utility helpers to determine which bookings should count toward slot utilisation.
// Certain workflow statuses (cancelled, postponed, rescheduled, etc.) free up a slot
// and should not be included when computing booked counts for calendars.

const STATUS_EXCLUSION_KEYWORDS = ["cancel", "postpon", "resched", "no-show", "noshow"];
const STATUS_FIELD_CANDIDATES = [
    "status",
    "lifecycle",
    "lifeCycle",
    "workflowStatus",
    "encounterStatus",
    "bookingStatus",
    "surgeryStatus",
];

const normalizeStatusValue = (value) => {
    if (value === null || typeof value === "undefined") {
        return "";
    }
    return String(value).trim().toLowerCase();
};

const extractStatusString = (bookingOrStatus) => {
    if (typeof bookingOrStatus === "string") {
        return bookingOrStatus;
    }
    if (bookingOrStatus === null || typeof bookingOrStatus !== "object") {
        return "";
    }

    for (const field of STATUS_FIELD_CANDIDATES) {
        if (typeof bookingOrStatus[field] !== "undefined") {
            return bookingOrStatus[field];
        }
    }

    return "";
};

export const shouldIncludeBookingInSlotMetrics = (bookingOrStatus) => {
    const status = normalizeStatusValue(extractStatusString(bookingOrStatus));

    if (!status) {
        return true;
    }

    return !STATUS_EXCLUSION_KEYWORDS.some((keyword) => status.includes(keyword));
};

export const filterBookingsForSlotMetrics = (bookings = []) => {
    if (!Array.isArray(bookings)) {
        return [];
    }
    return bookings.filter((booking) => shouldIncludeBookingInSlotMetrics(booking));
};


